export default __webpack_public_path__ + "static/media/Teachers_page.8bf5bc20.jpg";